export default __webpack_public_path__ + "static/media/1804.eeda16e2.png";